import "./NavButton.css";
import DropdownIcon from "../../assets/DropdownIcon.png";
function NavButton({ title, list }) {
  return (
    <div>
      <div className="paste-button">
        <div className="DropdownButton">
          {title} &nbsp; <img src={DropdownIcon} width={20} />
        </div>
        <div className="dropdown-content">
          {list.map((item) => (
            <a key={item.text} href={item.href} target="_blank">
              <img src={item.icon} width={24} />
              <p>{item.text}</p>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}

export default NavButton;
